import { render, staticRenderFns } from "./modalDetallePago.vue?vue&type=template&id=0c52a8c7&"
import script from "./modalDetallePago.vue?vue&type=script&lang=js&"
export * from "./modalDetallePago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports